import { useState, useMemo, createRef } from "react";

const percentVisible = (parent, child) => {
  if (!child) return 0;
  const childTop = child.offsetTop;
  const childBottom = childTop + child.clientHeight;
  const parentTop = parent.scrollTop;
  const parentBottom = parentTop + parent.clientHeight;
  const totalHeight = Math.max(childBottom, parentBottom) - Math.min(childTop, parentTop);
  const parentCompensation = totalHeight - parent.clientHeight;
  const portionVisible = child.clientHeight - parentCompensation;
  return portionVisible <= 0 ? 0 : portionVisible / child.clientHeight;
};

const useFolderTabs = (folderDefs) => {
  const refs = useMemo(() => {
    const obj = {};
    folderDefs.forEach((folder) => {
      obj[folder.tabName] = createRef();
    });
    return obj;
    // Ensure folderDefs is not recreated on every render by memoizing it
  }, [folderDefs]);

  const visibleTabs = folderDefs.filter((f) => f.show);

  const [activeTabName, setActiveTabName] = useState(visibleTabs[0]?.tabName || "");

  const onScroll = (e) => {
    let tmpVisible = 0;
    let pVisible = percentVisible(e.target, refs[visibleTabs[0].tabName].current);
    const activeTab = visibleTabs.reduce((p, folder) => {
      tmpVisible = percentVisible(e.target, refs[folder.tabName].current);
      if (tmpVisible >= pVisible) {
        pVisible = tmpVisible;
        return folder.tabName;
      }
      return p;
    }, visibleTabs[0].tabName);
    if (activeTabName !== activeTab) setActiveTabName(activeTab);
  };

  const tabs = visibleTabs.map((folder) => ({
    ...folder,
    ref: refs[folder.tabName],
  }));

  return {
    tabs,
    activeTabName,
    setActiveTabName,
    onScroll,
    refs,
  };
};

export default useFolderTabs;
